import { render } from 'vue'
import { isClient } from '@vueuse/core'
import { ModalError, ModalLoader } from '#components'

export interface FormState<T = Record<string, any>> {
  activeStep?: number
  values?: T
  [key: string]: any
}
export function useFormState(id: string) {
  const state = useState(`form-state-${id}`, () => ({ activeStep: 1 }))
  return state
}

export function useStoryblokProps<T extends { name: string }>(props: T): T {
  const fields = inject<any[]>('form-fields')
  const fieldContent: T = fields?.find((field) => {
    return field.name === props.name
  })
  const data = fieldContent || {}
  for (const [key, value] of Object.entries(toRefs(props)))
    if ((props[key] || props[key]?.length) && isClient) data[key] = value
  return toReactive(data) as T
}
export function useGetFieldText(name: string, value: string | number) {
  if (!value && !name) return
  const fields = inject<any[]>('form-fields')
  const field = fields?.find(field => field.name === name)
  if (!field) return
  const fieldContent = field?.items?.find((item: { value: string | number }) => item.value == value)
  return fieldContent.text
}

export function useLoading(options?: { duration?: number; title?: string; text?: string }) {
  const modal = document.createElement('aside')
  const locale = useAppConfig().locale.code
  render(h(ModalLoader, { locale, ...options }), modal)
  document.body.appendChild(modal)
  document.documentElement.style.setProperty('overflow', 'hidden')
  document.body.style.setProperty('overflow-y', 'scroll')
  return {
    close: () => {
      document.documentElement.style.removeProperty('overflow')
      document.body.style.removeProperty('overflow')
      modal.remove()
    },
  }
}
export function useErrorModal(options?: { text?: string }) {
  const app = useNuxtApp()
  const vnode = h(ModalError, options)
  vnode.appContext = app.vueApp._context

  render(vnode, document.body)
}
